module.exports = __webpack_public_path__ + "static/media/fantasyomatic-personas-persona-tammy@2x.43f81803.png";